import React, { useEffect, useState } from 'react';
import { Checkbox, Input, Select, Spin, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
//import clsx from 'clsx';
import {
  Article,
  useArticlesGetAll,
  useArticlesTagsGetAll,
} from '../../../hooks/api/articles';
//import { formatDate } from '../../../utils';
//import { IconArrow } from '../../Common/Icon';

import JoinOurCommunity from './JoinOurCommunity';

import styles from './index.module.scss';
//import DisplayHtmlContent from '../../Common/DisplayHtmlContent';
import TippingArticleList from './ArticlesList';

const { Option } = Select;

export default function ArticlesContent(): React.ReactNode | null {
  const articlesGetAll = useArticlesGetAll();
  const articlesTagsGetAll = useArticlesTagsGetAll();
  const { data, loading, error } = articlesGetAll;
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [page, setPage] = useState(1);
  const [loadedItems, setLoadedItems] = useState<Article[]>([]);
  const [, setSearchParams] = useSearchParams();
  //const navigate = useNavigate();

  useEffect(() => {
    if (selectedTags.length > 0) {
      setLoadedItems([]);
      articlesGetAll.fetch({ tags: selectedTags as [] });
    }
    if (selectedTags.length === 0) {
      setLoadedItems([]);
      articlesGetAll.fetch({ page });
    }
  }, [selectedTags]);

  useEffect(() => {
    if (page > 1) {
      articlesGetAll.fetch({ page });
    }
  }, [page]);

  useEffect(() => {
    if (!loading && !error && data) {
      setLoadedItems([...loadedItems, ...data.data]);
    }
  }, [data, loading, error]);
  const handleSearch = () => {
    setLoadedItems([]);
    setSearchParams({ search: searchQuery });
    articlesGetAll.fetch({ search: searchQuery, tags: selectedTags });
  };

  const handleChange = (checkedValues: React.SetStateAction<string[]>) => {
    setSelectedTags(checkedValues);
  };

  const tagOptions = articlesTagsGetAll.data?.data || [];

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <TippingArticleList
          articles={loadedItems}
          header={
            <>
              <div>
                <h1 style={{ color: '#282C35' }}>Tipping</h1>
                <h1 style={{ color: '#11B559' }}>Articles</h1>
              </div>
              <h3 style={{ color: '#040404' }}>
                Answers to the most common
                <br />
                tipping questions.
              </h3>
              <span className="article-span-item">
                Explore different perspectives on tipping culture and how
                tipping practices influence customers, workers, and businesses.
              </span>
              <Input
                suffix={<SearchOutlined />}
                size="large"
                placeholder="Search Articles"
                onChange={(e) => setSearchQuery(e.target.value)}
                onPressEnter={handleSearch}
              />
              <Select
                mode="multiple"
                showSearch
                size="large"
                // style={{ width: '100%' }}
                className={styles.tagsSelect}
                placeholder="Select Tags"
                value={selectedTags}
                onChange={handleChange}
                filterOption={(input, option) =>
                  !!option?.children.toLowerCase().includes(input.toLowerCase())
                }
                options={tagOptions.map((tag) => ({
                  label: (
                    <Checkbox
                      className={styles.customCheckbox}
                      checked={selectedTags.includes(tag.id)}
                    >
                      {tag.name}
                    </Checkbox>
                  ),
                  value: tag.id,
                  children: tag.name,
                }))}
              />
              {selectedTags.length > 0 && (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    flexWrap: 'wrap',
                  }}
                >
                  {selectedTags.map((item) => (
                    <Tag
                      key={item}
                      closable
                      onClose={() =>
                        setSelectedTags(selectedTags.filter((i) => i !== item))
                      }
                    >
                      {tagOptions.find((opt) => opt.id === item)?.name}
                    </Tag>
                  ))}
                </div>
              )}
            </>
          }
        />
      </div>

      {data?.data.length && data.total !== loadedItems.length ? (
        <div
          role="button"
          tabIndex={-1}
          style={{ fontSize: 20 }}
          className={styles.showMore}
          onClick={() => setPage(page + 1)}
        >
          Show more
        </div>
      ) : null}
      {/* <Button
        type="link"
        size="large"
        disabled={!data?.data.length}
        style={{ fontSize: 24 }}
        onClick={() => setPage(page + 1)}
      >
        Show more
      </Button> */}
      <JoinOurCommunity />

      {loading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
